import { Box, Button, Text, Center, Link, ButtonProps, Dialog } from '@chakra-ui/react'
import { PaywalledAction } from '@src/components/sco/PaywalledAction'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import { GroupEvent } from '@src/graphql-types'
import { gql } from '@src/lib/gql'
import { useState } from 'react'

type OfficeHoursSchedulerProps = {
  event: GroupEvent
  buttonProps?: ButtonProps
}

/** Prefer schedulingUrl (booking); fall back to callUrl for legacy Airtable rows. */
export const getEventBookingUrl = (event: { schedulingUrl?: string | null; callUrl?: string | null }) =>
  event.schedulingUrl || event.callUrl || null

export const OfficeHoursScheduler = (props: OfficeHoursSchedulerProps) => {
  const [showModal, setShowModal] = useState(false)
  const event = props.event
  const bookingUrl = getEventBookingUrl(event)

  const onClick = ev => {
    if (bookingUrl && bookingUrl.indexOf('calendly') !== -1) {
      setShowModal(true)
      ev.preventDefault()
    } else {
      return true
    }
  }

  if (!bookingUrl) {
    return (
      <Box
        bgColor={'backgroundTertiary'}
        borderRadius={'12px'}
        opacity={0.5}
        width={'full'}
        {...((props.buttonProps || {}) as any)}
      >
        <Center padding={'0.4em'}>
          <Text fontFamily={'Poppins, sans-serif'} fontSize={'10px'} fontWeight={'600'} textAlign={'center'}>
            Scheduling not available.
          </Text>
        </Center>
      </Box>
    )
  }

  return (
    <>
      <PaywalledAction contentPermission={'canAccessFGOfficeHours'} upgradeCtaLabel={'Schedule'}>
        <Button
          bgColor={[`${event.type?.colorHexCode}`, 'primary']}
          size={['sm', 'md']}
          width={'full'}
          {...(props.buttonProps || {})}
          asChild
        >
          <NextLink href={bookingUrl} target={'_blank'} onClick={onClick}>
            View Availability
          </NextLink>
        </Button>
      </PaywalledAction>
      <Dialog.Root
        open={showModal}
        onOpenChange={({ open }) => {
          if (!open) {
            setShowModal(false)
          }
        }}
      >
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bgColor={'backgroundSecondary'} maxWidth={'720px'}>
            <Dialog.Header>Schedule Office Hours Session</Dialog.Header>
            <Dialog.CloseTrigger />
            <Dialog.Body paddingY={'0'}>
              <Box
                borderTop={'1px solid'}
                borderTopColor={'whiteAlpha.200'}
                paddingBottom={'1em'}
                paddingTop={'1em'}
                textAlign={'center'}
              >
                {'Having issues?'}{' '}
                <Link href={bookingUrl} target={'_blank'} textDecoration={'underline'}>
                  View Scheduling Page
                </Link>
              </Box>
              <iframe
                src={bookingUrl}
                style={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  height: '70vh',
                  width: '100%',
                }}
              />
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Root>
    </>
  )
}

OfficeHoursScheduler.fragments = {
  GroupEvent: () => gql`
    fragment _ on GroupEvent {
      id
      callUrl
      schedulingUrl
    }
  `,
}
